import { ReactNode } from "react";
import { Header } from "@/components/Header";
import { MarketingFooter } from "@/components/MarketingFooter";
import { DemoScheduler } from "@/components/site/DemoScheduler";
import { CookieConsent } from "@/components/CookieConsent";

export function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main className="flex-1">{children}</main>
      <MarketingFooter />
      <CookieConsent />
      <DemoScheduler />
    </div>
  );
}
